type Callback = (...args: unknown[]) => unknown;

type ResultCallback = (...args: unknown[]) => void;

type TimeoutHandle = ReturnType<typeof setTimeout>;

export function debounce(callback: Callback, timeout = 300): ResultCallback {
	let timeoutHandle: TimeoutHandle;

	return (...args) => {
		clearTimeout(timeoutHandle);

		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		timeoutHandle = setTimeout(() => callback.apply(this, args), timeout);
	};
}

export function throttle(callback: Callback, timeout = 300): ResultCallback {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	let timeoutHandle: TimeoutHandle = null;

	return (...args) => {
		if (timeoutHandle !== null) return;

		callback(...args);

		timeoutHandle = setTimeout(() => {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			timeoutHandle = null;
		}, timeout);
	};
}
